import React from "react";
import "../styles.css";

const EquipmentHire = () => {
  return (
    <div className="equipment-hire-page">
      <section className="hire-hero">
        <p className="eyebrow">Local equipment hire in the Central Highlands</p>
        <h1>Equipment Hire</h1>
        <p className="hire-intro">
          Need equipment for a gig, event, rehearsal or project? Contact X Fire Music
          and tell us what you need. We&apos;ll confirm what is available and provide hire
          details and pricing.
        </p>
        <div className="hire-actions">
          <a className="store-btn store-btn-primary" href="tel:+61457170347">📞 Call About Hire</a>
          <a className="store-btn" href="mailto:info@xfiremusic.com.au?subject=Equipment%20Hire%20Enquiry">✉️ Email an Enquiry</a>
        </div>
      </section>

      <section className="hire-grid" aria-label="Equipment hire information">
        <article className="hire-card">
          <div className="hire-card-icon" aria-hidden="true">🎤</div>
          <h2>Tell us what you need</h2>
          <p>
            Let us know what the equipment is for, the date you need it and any other
            requirements. We can then check the most suitable options.
          </p>
        </article>

        <article className="hire-card">
          <div className="hire-card-icon" aria-hidden="true">📋</div>
          <h2>Confirm availability</h2>
          <p>
            Hire equipment and availability can vary, so contact us before making plans.
            We&apos;ll confirm availability, pricing and the hire period with you directly.
          </p>
        </article>

        <article className="hire-card">
          <div className="hire-card-icon" aria-hidden="true">🤝</div>
          <h2>Local service</h2>
          <p>
            Deal directly with X Fire Music in Emerald. We can discuss collection,
            return arrangements and anything else you need to know before the hire.
          </p>
        </article>
      </section>

      <section className="hire-enquiry-card">
        <div>
          <p className="eyebrow">Planning something?</p>
          <h2>Ask us about equipment hire</h2>
          <p>
            The full hire range is being updated. For current equipment, availability
            and pricing, contact us directly and we&apos;ll help you work out what you need.
          </p>
        </div>
        <div className="hire-contact-details">
          <a href="tel:+61457170347">📞 0457 170 347</a>
          <a href="mailto:info@xfiremusic.com.au?subject=Equipment%20Hire%20Enquiry">✉️ info@xfiremusic.com.au</a>
          <span>📍 10 Hospital Rd, Emerald QLD 4720</span>
        </div>
      </section>
    </div>
  );
};

export default EquipmentHire;
